var render = function () {
  var _vm$modalSelectedCust, _vm$modalSelectedCust2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "CustomerLevelsList",
      "extra-items": [{
        text: _vm.customerLevel.name,
        to: 'CustomerLevelsView',
        params: {
          id: this.$route.params.id
        }
      }, '會員等級列表']
    }
  })], 1)]), _c('b-overlay', {
    attrs: {
      "show": _vm.isFetching
    }
  }, [_c('b-card', [_c('h4', {
    staticClass: "mb-2 mb-xl-0 mr-2 font-weight-bold"
  }, [_vm._v(_vm._s("\u5DF2\u64C1\u6709".concat(_vm.customerLevel.name, "\u6703\u54E1\u7B49\u7D1A\u7684\u6703\u54E1")))]), _c('div', {
    staticClass: "d-flex justify-content-end align-items-center"
  }, [_c('b-dropdown', {
    staticClass: "flex-shrink-0 mr-2",
    attrs: {
      "variant": "inverse-info"
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('span', {
          staticClass: "mdi mdi-download"
        }), _vm._v(" 資料匯出 ")];
      },
      proxy: true
    }])
  }, [_c('b-dropdown-item', {
    on: {
      "click": function click($event) {
        return _vm.exportCustomers('excel');
      }
    }
  }, [_vm._v("下載 EXCEL")]), _c('b-dropdown-item', {
    on: {
      "click": function click($event) {
        return _vm.exportCustomers('csv');
      }
    }
  }, [_vm._v("下載 CSV")])], 1), _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "inverse-info",
      "to": {
        name: 'CustomerLevelsLog',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_c('span', {
    staticClass: "mdi mdi-note-multiple"
  }), _vm._v("異動紀錄 ")]), _vm.customerLevel.is_line_module ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "inverse-info"
    },
    on: {
      "click": _vm.showImportModal
    }
  }, [_c('span', {
    staticClass: "mdi mdi-cloud-upload"
  }), _vm._v(" 批次上傳 ")]) : _vm._e(), _c('StaffAddCustomer', {
    ref: "staffAddCustomer",
    attrs: {
      "add-button-text": "加入會員",
      "sourceType": _vm.customerMerchantType
    },
    on: {
      "bind": _vm.bindCustomer
    }
  })], 1), _c('b-card', {
    staticClass: "mt-2 mb-3"
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "請輸入手機、姓名、暱稱關鍵"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleKeywordSearch.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handleKeywordSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.customers,
      "fields": _vm.fields,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "no-local-sorting": true
    },
    on: {
      "update:sortBy": function updateSortBy($event) {
        _vm.sortBy = $event;
      },
      "update:sort-by": function updateSortBy($event) {
        _vm.sortBy = $event;
      },
      "update:sortDesc": function updateSortDesc($event) {
        _vm.sortDesc = $event;
      },
      "update:sort-desc": function updateSortDesc($event) {
        _vm.sortDesc = $event;
      },
      "sort-changed": _vm.handleSort
    },
    scopedSlots: _vm._u([{
      key: "cell(avatar_url)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "d-flex align-items-center justify-content-center"
        }, [_c('router-link', {
          attrs: {
            "to": {
              name: 'CustomerDetailView',
              params: {
                customerID: data.item.id
              }
            }
          }
        }, [_c('b-avatar', {
          attrs: {
            "src": data.item.avatar_url,
            "variant": "secondary",
            "size": "2rem"
          }
        })], 1)], 1)];
      }
    }, {
      key: "cell(name)",
      fn: function fn(data) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'CustomerDetailView',
              params: {
                customerID: data.item.id
              }
            }
          }
        }, [_vm._v(_vm._s(_vm._f("hiddenString")(data.item.name, 20)))])];
      }
    }, {
      key: "cell(logs[0].start_at)",
      fn: function fn(data) {
        var _data$item$logs, _data$item$logs$;
        return [_vm._v(" " + _vm._s(_vm.formatDate((_data$item$logs = data.item.logs) === null || _data$item$logs === void 0 ? void 0 : (_data$item$logs$ = _data$item$logs[0]) === null || _data$item$logs$ === void 0 ? void 0 : _data$item$logs$.start_at)) + " ")];
      }
    }, {
      key: "cell(logs[0].end_at)",
      fn: function fn(data) {
        var _data$item$logs2, _data$item$logs2$;
        return [_vm._v(" " + _vm._s(_vm.formatDate((_data$item$logs2 = data.item.logs) === null || _data$item$logs2 === void 0 ? void 0 : (_data$item$logs2$ = _data$item$logs2[0]) === null || _data$item$logs2$ === void 0 ? void 0 : _data$item$logs2$.end_at)) + " ")];
      }
    }, {
      key: "cell(logs[0].created_at)",
      fn: function fn(data) {
        var _data$item$logs3, _data$item$logs3$;
        return [_vm._v(" " + _vm._s(_vm.formatDate((_data$item$logs3 = data.item.logs) === null || _data$item$logs3 === void 0 ? void 0 : (_data$item$logs3$ = _data$item$logs3[0]) === null || _data$item$logs3$ === void 0 ? void 0 : _data$item$logs3$.created_at)) + " ")];
      }
    }, {
      key: "cell(action)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "d-flex justify-content-center"
        }, [_c('b-button', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal",
            value: 'modal-choose-customer-time',
            expression: "'modal-choose-customer-time'"
          }],
          staticClass: "mr-2",
          attrs: {
            "variant": "inverse-info",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return _vm.chooseCustomerTime(data.item);
            }
          }
        }, [_vm._v(" 設定 ")]), _c('b-button', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal",
            value: 'modal-edit-customer-level',
            expression: "'modal-edit-customer-level'"
          }],
          attrs: {
            "variant": "inverse-danger",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return _vm.editCustomerLevel(data.item);
            }
          }
        }, [_vm._v(" 等級異動 ")])], 1)];
      }
    }])
  })], 1)]), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-batch-assign",
      "title": "批次匯入"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var cancel = _ref.cancel;
        return [_c('b-button', {
          staticClass: "float-right",
          attrs: {
            "variant": "outline-danger",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" 取消 ")]), _vm.batchAssignStep == 1 ? _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-primary"
          },
          on: {
            "click": _vm.previewCustomer
          }
        }, [_vm._v(" 下一步 ")]) : _vm._e(), _vm.batchAssignStep == 2 ? _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-primary"
          },
          on: {
            "click": _vm.goBackBatchAssign
          }
        }, [_vm._v("回上一步")]) : _vm._e(), _vm.batchAssignStep == 2 ? _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-primary"
          },
          on: {
            "click": _vm.importCustomer
          }
        }, [_vm._v(" 確定匯入 ")]) : _vm._e()];
      }
    }])
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoadingUpload
    }
  }, [_vm.batchAssignStep == 1 ? [_c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "text-danger"
  }, [_vm._v("依 LINE ID、手機號碼 順序比對會員")]), _c('b-form-file', {
    attrs: {
      "plain": "",
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    model: {
      value: _vm.batchAssignFile,
      callback: function callback($$v) {
        _vm.batchAssignFile = $$v;
      },
      expression: "batchAssignFile"
    }
  }), _c('b-button', {
    staticClass: "mt-2",
    attrs: {
      "size": "sm",
      "variant": "outline-primary",
      "href": "/excel/batch_assign_redeem_code.xlsx"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text"
  }), _vm._v("下載範例檔案 ")])], 1)] : _vm.batchAssignStep == 2 ? [_c('div', {
    staticClass: "form-group"
  }, [_c('p', [_vm._v(" 上傳資料筆數：" + _vm._s(_vm.importCustomerPreview.total_member_count)), _c('br'), _vm._v(" 對應會員數量：" + _vm._s(_vm.importCustomerPreview.valid_member_count)), _c('br')]), _vm.importCustomerPreview.valid_member_count != _vm.importCustomerPreview.total_member_count ? _c('p', {
    staticClass: "text-danger"
  }, [_vm._v(" 上傳資料數量與對應會員數量不同，請問是否確定匯入 ")]) : _vm._e()])] : _vm._e()], 2)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-choose-customer-time",
      "title": _vm.customerTimeTitle,
      "centered": ""
    },
    on: {
      "hidden": _vm.resetModal,
      "ok": _vm.handleChooseCustomerTime
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref2) {
        var ok = _ref2.ok,
          cancel = _ref2.cancel;
        return [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "danger"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" 取消 ")]), _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "success"
          },
          on: {
            "click": function click($event) {
              return ok();
            }
          }
        }, [_vm._v(" 確認送出 ")])];
      }
    }])
  }, [_c('form', {
    ref: "form",
    on: {
      "submit": function submit($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.handleChooseCustomerTime.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "* 開始時間"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "input-class": _vm.v$.startAt.date.$error ? 'is-invalid' : ''
    },
    on: {
      "selected": _vm.onStartDateSelected
    },
    model: {
      value: _vm.startAt.date,
      callback: function callback($$v) {
        _vm.$set(_vm.startAt, "date", $$v);
      },
      expression: "startAt.date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.startAt.date.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('vue-timepicker', {
    attrs: {
      "placeholder": "選擇時間",
      "input-class": ['form-control', {
        'is-invalid': _vm.v$.startAt.time.HH.$error || _vm.v$.startAt.time.mm.$error
      }],
      "disabled": ""
    },
    model: {
      value: _vm.startAt.time,
      callback: function callback($$v) {
        _vm.$set(_vm.startAt, "time", $$v);
      },
      expression: "startAt.time"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.startAt.time.HH.$error || !_vm.v$.startAt.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)])]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.isEndAtRequired ? '* 結束時間' : '結束時間'
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "clear-button": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "input-class": _vm.v$.endAt.date.$error ? 'is-invalid' : ''
    },
    on: {
      "selected": _vm.onEndDateSelected
    },
    model: {
      value: _vm.endAt.date,
      callback: function callback($$v) {
        _vm.$set(_vm.endAt, "date", $$v);
      },
      expression: "endAt.date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.endAt.date.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('vue-timepicker', {
    attrs: {
      "placeholder": "選擇時間",
      "input-class": ['form-control', {
        'is-invalid': _vm.v$.startAt.time.HH.$error || _vm.v$.startAt.time.mm.$error
      }],
      "disabled": ""
    },
    model: {
      value: _vm.endAt.time,
      callback: function callback($$v) {
        _vm.$set(_vm.endAt, "time", $$v);
      },
      expression: "endAt.time"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.endAt.time.HH.$error || !_vm.v$.endAt.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)])])], 1)]), _c('b-modal', {
    attrs: {
      "id": "modal-edit-customer-level",
      "title": "會員等級異動",
      "centered": ""
    },
    on: {
      "hidden": _vm.resetModal,
      "ok": _vm.handleEditCustomerLevel
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref3) {
        var ok = _ref3.ok,
          cancel = _ref3.cancel;
        return [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "danger"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" 取消 ")]), _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "success"
          },
          on: {
            "click": function click($event) {
              return ok();
            }
          }
        }, [_vm._v(" 確定異動 ")])];
      }
    }])
  }, [_c('h4', [_vm._v(_vm._s((_vm$modalSelectedCust = (_vm$modalSelectedCust2 = _vm.modalSelectedCustomer) === null || _vm$modalSelectedCust2 === void 0 ? void 0 : _vm$modalSelectedCust2.name) !== null && _vm$modalSelectedCust !== void 0 ? _vm$modalSelectedCust : "") + " 目前等級為 " + _vm._s(_vm.customerLevel.name))]), _c('p', [_vm._v("請選擇會員新等級")]), _c('form', {
    ref: "form",
    on: {
      "submit": function submit($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.handleEditCustomerLevel.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', [_c('b-form-select', {
    model: {
      value: _vm.modalSelectedCustomerNewLevelId,
      callback: function callback($$v) {
        _vm.modalSelectedCustomerNewLevelId = $$v;
      },
      expression: "modalSelectedCustomerNewLevelId"
    }
  }, _vm._l(_vm.enabledLevels, function (level) {
    return _c('b-form-select-option', {
      key: level.value,
      attrs: {
        "value": level.value,
        "disabled": level.value === _vm.customerLevel.id
      }
    }, [_vm._v(" " + _vm._s(level.text) + " ")]);
  }), 1)], 1)], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }